// extracted by mini-css-extract-plugin
export var image = "appStoreImage-module--image--RME8-";